import { render, staticRenderFns } from "./PartnersCarousel.vue?vue&type=template&id=146e310a&scoped=true&"
import script from "./PartnersCarousel.vue?vue&type=script&lang=js&"
export * from "./PartnersCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e310a",
  null
  
)

export default component.exports